import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

function ErrorAlertIcon(props: Readonly<SvgIconProps & { disabled?: boolean }>): JSX.Element {
    return (
        <SvgIcon viewBox='0 -960 960 960' {...props}>
            <path
                d='M480-120q-33 0-56.5-23.5T400-200q0-33 23.5-56.5T480-280q33 0 56.5 23.5T560-200q0 33-23.5 56.5T480-120Zm-80-240v-480h160v480H400Z'
                fill={props.disabled ? '#AAAAAA' : '#EA3323'}
                className={props.className}
            />
        </SvgIcon>
    );
}

export default React.memo(ErrorAlertIcon);
